// ar_AE language file
// Generated from Feishu Bitable
// Total entries: 565

export default{
    "game_diamond": {
        "title": "معلومات عن جواهر اللعبة",
        "title0_title": "كيفية الحصول على جواهر اللعبة",
        "title0": {
            "txt1": "1. يمكنك الحصول عليها من مهام أو فعاليات محددة.",
            "txt2": "2. لا يمكن شراؤها عن طريق الشحن."
        },
        "title1_title": "استخدامات جواهر اللعبة",
        "title1": {
            "txt1": "1. تُستخدم فقط في الألعاب.",
            "txt2": "2. داخل اللعبة، جواهر اللعبة تعادل الألماس العادي ويمكن استخدامها مباشرة. الألماس الذي تربحه بجواهر اللعبة يُعتبر ألماسًا عاديًا.",
            "txt3": "3. يتم استخدام جواهر اللعبة أولاً.",
            "txt4": "4. يمكن استخدامها مع الجواهر العادية. مثال: لديك ٢٠٠ جوهرة لعبة و٨٠٠ عادية، سيتم استخدام جميعها عند الحاجة لـ١٠٠٠."
        },
        "title2_title": "صلاحية جواهر اللعبة",
        "title2": {
            "txt1": "1. صالحة لفترة محددة وسيتم سحبها بعد انتهاء الصلاحية."
        }
    },
    "guanxi_gift_rule_title": "وصف الهدية",
    "guanxi_gift_rule_1": "بعد إرسال هدية علاقة، يمكن للمستلم اختيار ما إذا كان يريد تشكيل علاقة معك. يمكن أن توجد علاقة واحدة فقط بين شخصين في نفس الوقت.",
    "guanxi_gift_rule_2": "يمكن لكل شخص أن يكون لديه ما يصل إلى 3 علاقات، ويمكن أن تكون أنواع العلاقات متشابهة.",
    "guanxi_gift_rule_3": "يمكنك إنهاء العلاقة بعد 24 ساعة من تشكيلها. بعد إنهاء العلاقة، يمكنك تكوين علاقة جديدة بعد 24 ساعة أخرى.",
    "not_exist": "غير موجود",
    "mbti_intro_title": "أوصاف MBTI",
    "mbti_intro_pers": "السمات الشخصية",
    "mbti_intro_love": "الصفات العاطفية",
    "mbti_intro_istj_pers": "شخصية المفتش",
    "mbti_intro_istj_feature": "جادون وهادئون، يركزون على التفاصيل والدقة، يفضلون الحياة المنظمة والمرتبة. موثوقون ومسؤولون، يتبعون القواعد والتقاليد.",
    "mbti_intro_istj_love": "في الحب، يعتبر الـ ISTJ شركاء أوفياء ومستقرين. يأخذون العلاقات بجدية، ويركزون على الالتزام والمسؤولية، ويظهرون اهتمامهم من خلال الأفعال بدلاً من الكلمات، ويحتاجون إلى الوقت لتكوين روابط عميقة.",
    "mbti_intro_isfj_pers": "شخصية الراعي",
    "mbti_intro_isfj_feature": "لطيفون، طيبون ومتعاطفون، يلبون احتياجات الآخرين بصبر واهتمام. يركزون على التفاصيل ويجيدون الاستماع والدعم.",
    "mbti_intro_isfj_love": "في العلاقات، يكون الـ ISFJ عميق الاهتمام، ويهتم بتفاصيل حياة الشريك، ويخلق جوًا دافئًا ومريحًا. غالبًا ما يكون تقليديًا ويأخذ وقتًا للالتزام، ولكنه شديد الولاء عند الالتزام.",
    "mbti_intro_infj_pers": "شخصية المهندس",
    "mbti_intro_infj_feature": "يتمتعون ببصيرة وإبداع، ولديهم فهم عميق للإنسانية والمستقبل. حياتهم الداخلية غنية وهم مفكرون وتحليليون.",
    "mbti_intro_infj_love": "يبحث الـ INFJ عن ارتباط عقلي وعاطفي مع الشريك ويقدرون المحادثات العميقة. لديهم مثالية عالية في الحب، وعندما يحبون يكونون مركزين ومخلصين.",
    "mbti_intro_intj_pers": "شخصية القائد",
    "mbti_intro_intj_feature": "منطقيون، هادئون وواثقون، لديهم مهارات تحليلية واتخاذ قرارات قوية، يقدرون المعرفة والحكمة ويطاردون أهدافهم بعزيمة.",
    "mbti_intro_intj_love": "في العلاقات، يتعامل الـ INTJ مع الحب بطريقة عقلانية، ويقدرون المعتقدات والأهداف المشتركة. رغم تحفظهم العاطفي، يعبرون عن اهتمامهم من خلال الأفعال المدروسة.",
    "mbti_intro_istp_pers": "شخصية الحرفي",
    "mbti_intro_istp_feature": "عملي، ملاحظ وتحليلي، يستمتع بالمهام اليدوية وحل المشكلات العملية، خاصة في المجالات الميكانيكية أو التقنية.",
    "mbti_intro_istp_love": "الـ ISTP عفويون وأحرار في العلاقات، يستمتعون باللحظة مع شركائهم ويشاركون ملذات الحياة دون قيود.",
    "mbti_intro_isfp_pers": "شخصية الفنان",
    "mbti_intro_isfp_feature": "حساسون، لطيفون وفنيون، يفضلون التجارب العاطفية والحسية، ويعبرون عن أنفسهم غالباً من خلال الأشكال الإبداعية.",
    "mbti_intro_isfp_love": "في العلاقات، يكون الـ ISFP رومانسيًا ومهتمًا، ويجيد خلق أجواء ساحرة وغالباً ما يُسعد شريكه بالمفاجآت. قد يكون عاطفيًا ويحتاج إلى شريك يفهمه ويدعمه.",
    "mbti_intro_infp_pers": "شخصية الوسيط",
    "mbti_intro_infp_feature": "مثاليون، طيبون ومتعاطفون، لديهم حياة داخلية غنية وفهم عميق للطبيعة البشرية، ويقدرون التناغم والجمال.",
    "mbti_intro_infp_love": "يستثمر الـ INFP بعمق في العلاقات ويبحثون عن روابط عاطفية قوية. يقدرون التبادل العاطفي ويشتركون في رؤية إيجابية عن الحب.",
    "mbti_intro_intp_pers": "شخصية المفكر",
    "mbti_intro_intp_feature": "تحليليون وفضوليون، لديهم رغبة قوية في المعرفة واستكشاف المناطق المجهولة سعياً وراء الحقيقة.",
    "mbti_intro_intp_love": "في العلاقات، يتعامل الـ INTP بطريقة منطقية ويركز على التوافق الفكري والعاطفي. قد يكونون متحفظين في التعبير عن مشاعرهم، لكنهم يستخدمون النقاش لتعزيز التفاهم المتبادل.",
    "mbti_intro_estp_pers": "شخصية الريادي",
    "mbti_intro_estp_feature": "نشيطون، منفتحون ومغامرون، يستمتعون بالتفاعل الاجتماعي وأخذ المخاطر ويقتنصون الفرص بنشاط.",
    "mbti_intro_estp_love": "في العلاقات، يتميز الـ ESTP بالحيوية والشغف، ويحبون استكشاف تجارب جديدة مع شركائهم. يتحدثون بصراحة ويعبرون عن أفكارهم ومشاعرهم دون تحفظ.",
    "mbti_intro_esfp_pers": "شخصية المؤدي",
    "mbti_intro_esfp_feature": "منفتحون، متفائلون ومعبرون، يستمتعون بالاختلاط والترفيه ويضفون الطاقة والحماس.",
    "mbti_intro_esfp_love": "في الحب، يكون الـ ESFP شركاء مفعمين بالحيوية، يستمتعون بالأنشطة الاجتماعية المشتركة، ويعطون الأولوية للمشاعر والتجارب الحالية، مما يجلب الفرح والحماس لشركائهم.",
    "mbti_intro_enfp_pers": "شخصية الداعم",
    "mbti_intro_enfp_feature": "مبدعون، مليئون بالطاقة ودافئون، يحبون التفاعل مع الآخرين ويفهمون مشاعرهم بعمق.",
    "mbti_intro_enfp_love": "يعتبر الـ ENFP كأشعة الشمس في العلاقات، يجلبون الدفء والفرح لشركائهم. مليئون بالرومانسية، يعبرون عن حبهم بنشاط ويتطلعون لصنع ذكريات جميلة معًا.",
    "mbti_intro_entp_pers": "شخصية المناظر",
    "mbti_intro_entp_feature": "أذكياء، لامعون وفضوليون، يستمتعون بالمناظرات واستكشاف الأفكار والمواضيع الجديدة.",
    "mbti_intro_entp_love": "يشارك الـ ENTP في نقاشات عميقة ومناظرات مع شركائهم، ويستمتعون بالتحديات والنمو الفكري في الحب. غالباً ما يكونون مرحين ويضفون حس الفكاهة للعلاقة.",
    "mbti_intro_estj_pers": "شخصية المنفذ",
    "mbti_intro_estj_feature": "عملي، حاسم واثق، يمتلكون مهارات تنظيم وقيادة قوية، ويعطون الأولوية للكفاءة والنتائج.",
    "mbti_intro_estj_love": "في الحب، يكون الـ ESTJ حازمًا ومصممًا، يتابع اهتماماته بنشاط ويخطط للمستقبل. يظهرون العاطفة من خلال الدعم العملي والأفعال.",
    "mbti_intro_esfj_pers": "شخصية المستشار",
    "mbti_intro_esfj_feature": "ودودون ودافئون، اجتماعيون ويهتمون بالآخرين، يقدرون التقاليد وروابط الأسرة.",
    "mbti_intro_esfj_love": "يكون الـ ESFJ شركاء منتبهين وحنونين، يخلقون بيئة رومانسية دافئة ومنسجمة. غالباً ما يكونون تقليديين، ويقدرون عادات المواعدة المألوفة وموافقة العائلة.",
    "mbti_intro_enfj_pers": "شخصية القائد",
    "mbti_intro_enfj_feature": "كاريزميون وواثقون، يتواصلون بسهولة ويفهمون ويقودون الآخرين بفاعلية.",
    "mbti_intro_enfj_love": "الـ ENFJ شركاء متحمسون ورومانسيون، يعبرون عن حبهم بصراحة ويخلقون جواً دافئاً. يقدرون التبادل العاطفي ويهدفون لتكوين رابطة عميقة مع شركائهم.",
    "mbti_intro_entj_pers": "شخصية المدير التنفيذي",
    "mbti_intro_entj_feature": "منطقيون، واثقون وطموحون، يتمتعون بمهارات قوية في القيادة واتخاذ القرار، يقدرون التميز والنجاح، ويضعون معايير عالية لأنفسهم وللآخرين.",
    "mbti_intro_entj_love": "في الحب، يركز الـ ENTJ على الأهداف، ويختارون شركاء يشتركون في نفس العقلية ويدعمون النمو المتبادل. يعطون الأولوية للكفاءة والطموحات المشتركة، ويعمقون العلاقات من خلال الأهداف المشتركة.",
    "expressProposalWall": "مكان الحب",
    "expressHowTo": "كيفية نشر كلمات على مكان الحب",
    "expressSend": "أرسل هدية الحب إلى حبيبك وسيظهر نصك الذي يعبر عن الحب على مكان الحب.",
    "expressSend1": "1.اضغط على \"قول حبك\"، يمكنك الانتقال إلى الحفلة واختيار المستخدم لرسائل من القلب.",
    "expressSend2": "2.اختر الهدية وأدخل الكلمات التي تريد أن تقول لها/ له على البطاقة.",
    "expressSend3": "3.اضغط لإرسال الهدية وستظهر بطاقة الحب الخاصة بك على مكان الحب.",
    "expressDifferent": "أنواع مختلفة من هدايا الحب",
    "expressWeHave": "لدينا 4 أنواع من هدايا الحب حسب كما يلي.",
    "expressWeHave1": "1.بطاقة هدية الحب الأساسي: خلفية ملونة بسيطة.",
    "expressWeHave2": "2. بطاقة هدية الحب الديكور: خلفية ملونة مزخرفة.",
    "expressWeHave3": "3.بطاقة هدية الحب الفاخر: خلفية مزخرفة بتأثير فاخر.",
    "expressWeHave4": "4.بطاقة هدايا الحب الحقيقي: خلفية مزخرفة ذات تأثير فاخر، مع شريط الاعلان الرائع على مستوى الخادم.",
    "expressProposal": "نطاق عرض بطاقة الحب",
    "expressProposal1": "1.مكان الحب في الغرفة. (اضغط على الشريط الموجود أعلى الهدايا الحب)",
    "expressProposal2": "2.مكان الحب بجانب صفحة اللحظة.",
    "diamondDrop1": "1.عندما يرسل المستخدم هدايا مجموعها أكثر من 50000 ألماسة مرة واحدة في الغرفة (يتم حساب الهدايا المحظوظة= سعر الماس الخاص بها*0.1)، يظهر صندوق ألماس في الغرفة ويمكن لأي شخص فتحه للحصول على الألماس.",
    "diamondDrop2": "2.كل صندوق يحتوي على عد تنازلي لمدة دقيقة واحدة قبل أن يتم فتحه.",
    "diamondDrop3": "3.الألماس في كل صندوق محدود؛ بمجرد انتهاء العد التنازلي، لا يمكنك الحصول على الألماس من ذلك الصندوق بعد الآن.",
    "diamondDrop4": "4.بعد إغلاق الصندوق، يمكنك النقر لرؤية عدد الألماسات التي حصلت عليها منه.",
    "baoxaingxianding": "صندوق الكنز المحدود",
    "cancelAccount": {
        "accountRecoveryContent": "خلال فترة الاسترداد، يمكنك تسجيل الدخول مرة أخرى باستخدام طريقتك السابقة واختيار استعادة حسابك. بمجرد استعادة الحساب، ستستعيد جميع رسائل الحساب والمستويات والألماس.",
        "accountRecoveryTitle": "استعادة الحساب:",
        "confirmCancellation": "هل أنت متأكد من أنك تريد الحذف؟",
        "convalescenceContent": "بعد تقديم طلب الحذف، سيتم تعطيل حسابك مؤقتًا لمدة 30 يومًا. خلال هذا الوقت، سيتم الاحتفاظ بجميع معلومات حسابك والمستويات والألماس، مما يسمح بالاسترداد بسهولة إذا غيرت رأيك.",
        "convalescenceTitle": "فترة الاسترداد:",
        "finalContent": "إذا لم تختر استعادة حسابك بنهاية فترة الاسترداد (31 يومًا من طلب الحذف)، سيتم حذف حسابك وجميع البيانات المرتبطة به بشكل دائم. يرجى ملاحظة أنه بمجرد الحذف، لا يمكن استرداد حسابك وبياناتك.",
        "finalTitle": "الحذف النهائي:",
        "reserveContent": "خلال فترة الاسترداد، سنحمي بيانات حسابك لضمان عدم فقدانها أو تلفها.",
        "reserveTitle": "الاحتفاظ بالبيانات:",
        "statementContent": "طلب الحذف: بعد تقديم طلب حذف الحساب، سيدخل حسابك فترة \"استرداد\" مدتها 30 يومًا. خلال هذا الوقت، يمكنك اختيار استعادة حسابك في أي وقت. إذا كنت جزءًا من وكالة، فلن يكون حذف الحساب ممكنًا.",
        "statementTitle": "إشعار حذف الحساب:",
        "userContent": "شكرًا لاستخدامك خدماتنا. نحن نتفهم أنه قد تحتاج أحيانًا إلى حذف حسابك. لضمان أن يكون قرارك مدروسًا جيدًا ولتوفير فرصة لإعادة النظر، نوضح هنا عملية حذف الحساب والشروط ذات الصلة.",
        "userTitle": "عزيزي المستخدم:"
    },
    "Countdown": "العد التنازلي",
    "Endactivity": "انتهى الحدث",
    "eventDetails": "تفاصيل الحدث",
    "eventGifts": "هدايا الحدث",
    "eventList": "قائمة المتصدرين في الحدث",
    "eventReward": "مكافآت الحدث",
    "eventRewards": {
        "player": "اللاعبين النشطين يوميا",
        "proportion": "معدل عائد الجائزة",
        "title": "جوائز الحدث",
        "txt1": "1. يتم حساب بيانات اليوم السابق يوميًا في الساعة 00:00 (UTC+8).",
        "txt2": "2. تُمنح الجوائز بناءً على عدد المشاركين والماس الفعلي الذي تم إنفاقه في الغرفة (رهانات المستخدم ناقص أرباح المستخدم).",
        "txt3": "3. يتم حساب بيانات الأسبوع السابق كل يوم اثنين في الساعة 00:00 (UTC+8)، ويتم توزيع المكافآت في غضون 3 أيام.",
        "txt4": "4. معدل عائد الجائزة:",
        "txt5": "5. تعريف اللاعب النشط: اللاعب الذي يراهن بأكثر من 1000 ماسة في اليوم."
    },
    "EventRules": "قواعد الحدث",
    "Eventtime": "وقت الحدث",
    "guild": {
        "guild_certification01": "تحقق الوكالة",
        "guild_certification02": "مرحبًا بالوكالة",
        "guild_certification03": "متطلبات التوظيف",
        "guild_certification04": [
            "أكمال التوقيع مع 10 مضيفين واستقرارهم خلال أسبوع واحد",
            "قادر على تقديم هوية قائد الوكالة والمستندات الأخرى باسم حقيقي",
            "تقديم ملف تعريفي للوكالة، تقديم الفريق، معلومات المذيعين، قواعد أرباح المذيعين، إلخ."
        ],
        "guild_certification05": "إذا كنت تفي بالمتطلبات المذكورة أعلاه، أرسل معلوماتك إلى البريد الإلكتروني الرسمي: billionairepte@gmail.comبمجرد الموافقة، سيتصل بك أحد الموظفين.",
        "guild_certification06": "تم النسخ إلى الحافظة",
        "guild_certification07": "جهة الاتصال للاستفسار",
        "guild_certification08": "نسخ",
        "guild_certification09": "معلومات العضوية",
        "guild_certification10": [
            {
                "title": "1. قواعد العضوية",
                "value": [
                    "يجب أن يوافق المتقدمون مع زعيم الوكالة لبدء طلب العضوية على المنصة. بمجرد موافقة الزعيم، يصبحون مذيعين موقعين، يساهمون في الوكالة."
                ]
            },
            {
                "title": "2. قواعد الاستقالة",
                "value": [
                    "لمغادرة الوكالة بعد الانضمام، يحتاج المذيع إلى موافقة قائد الوكالة. انقر على \\\"مغادرة الوكالة\\\" في صفحة الملف الشخصي للوكالة. يجب على قائد الوكالة النقر على \"موافق على المغادرة\" ثم يغادر العضو الوكالة.",
                    "بعد نجاح الانسحاب، يمكنك التقدم للانضمام إلى وكالة أخرى."
                ]
            }
        ],
        "guild_certification11": "معلومات الوكالة",
        "guild_certification12": [
            {
                "title": "دخل الوكالة",
                "value": [
                    "يتلقى المستخدمون والمذيعون في غرف العائلة الهدايا، مما يولد مساهمات للوكالة.",
                    "تحدث هجمات الرئيس في غرف العائلة.",
                    "المذيعون الموقعون مع الوكالة ينشئون غرف CP، وتلقي الهدايا يولد مساهمات للوكالة. (لا يمكن للمذيعين غير الموقعين إنشاء غرف CP وتوليد مساهمات للعائلة بعد الانضمام إلى العائلة.)"
                ]
            }
        ],
        "InvitationCodeTitle": "رمز الدعوة",
        "invite_rules_intriduction": "قواعد الدعوة",
        "invite_rules_intriduction_content": [
            "يمكن للمذيعين التقدم للانضمام إلى وكالتك ويصبحون مذيعين عن طريق إدخال رمز الدعوة أثناء التسجيل.",
            "المذيعون الذين لم يدخلوا رمز الدعوة أثناء التسجيل يمكنهم التقدم للانضمام إلى عائلتك من خلال صفحة العائلة، ثم التقدم ليصبحوا مذيعين."
        ]
    },
    "legend": {
        "title": "فبراير الأسطوري"
    },
    "officialMember": "الموظفين الرسميين",
    "prettyNumber": {
        "text": "Ⅰ. جمع معرف خاص",
        "text1": "بعد الوصول إلى المستوى النبيل 3 أو أعلى، يمكنك الحصول على معرف خاص يتوافق مع مستواك.",
        "text2": "يمكن للنبلاء ذوي المستوى الأعلى الحصول على معرف خاص بمستوى أقل. على سبيل المثال، يمكن للنبلاء 6 الحصول على معرف خاص من المستوى 3.",
        "text3": "عندما تنتهي حالة النبلاء الخاصة بك، يصبح المعرف الخاص غير متاح أيضًا. تحتاج إلى إعادة تفعيل نبلك للاستمرار في استخدام المعرف الخاص.",
        "text5": "بمجرد الحصول على معرف خاص، لا يمكنك استبداله بمعرف آخر من نفس المستوى أو مستوى أقل.",
        "text6": "إذا حققت مستوى نبيلاً أعلى أثناء استخدام معرف خاص، يمكنك التبديل فوراً إلى معرف خاص بمستوى أعلى، وسيعود المعرف الأصلي إلى المتجر.",
        "text7": "على سبيل المثال، لا يمكن لمستخدم نوبل 4 الذي يطلب في البداية معرف نوبل 4 خاص ثم يقوم بالترقية إلى نوبل 6 التبديل إلى معرف نوبل 4 أو أقل، ولكنه يمكنه فوراً المطالبة بمعرف نوبل 6 خاص.",
        "title": "توضيح",
        "title1": "انتهاء صلاحية الأي دي الخاص",
        "title2": "Ⅲ. استبدال الأي دي الخاص"
    },
    "reception": {
        "reception01": "شرح قائمة المتصدرين للهدايا",
        "reception02": [
            {
                "title": "ما هي قائمة المتصدرين للهدايا في الغرفة؟",
                "value": [
                    "قائمة المتصدرين للهدايا في الغرفة هي ترتيب لحظي للهدايا التي تم تلقيها في الغرفة",
                    "عدد الهدايا في الغرفة = عدد هدايا الألماس"
                ]
            },
            {
                "title": "كيف يتم ترتيب قائمة المتصدرين للهدايا في الغرفة؟",
                "value": [
                    "الترتيب يتم تحديده بناءً على إجمالي دخل جميع الغرف، ويتم حسابه بشكل شامل",
                    "قائمة المتصدرين بالساعة: يتم إعادة ضبطها كل ساعة عند UMT+8",
                    "قائمة المتصدرين اليومية: يتم إعادة ضبطها في 00:00 UMT+8 كل يوم"
                ]
            },
            {
                "title": "يتم بث المركز الأول في قائمة المتصدرين بالساعة على مستوى الخادم",
                "value": [
                    "يتم الإعلان عن الغرفة التي تحتل المركز الأول في قائمة المتصدرين بالساعة على مستوى جميع غرف الخادم"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "رجوع",
        "event_rule": "<p>1. قائمة المتصدرين لمدة الوقت: يتتبع إجمالي الوقت الذي يقضيه المستخدمون في جميع مواقع الميكروفون بالغرفة خلال الحدث. أعلى 3 مساهمين في أعلى 3 غرف سيحصلون على مكافآت.</p><p>2. قائمة السخاء: تتتبع العدد الإجمالي للألماس المستلم في الغرفة خلال الحدث. أعلى 3 مستهلكين للألماس في أعلى 3 غرف سيحصلون على مكافآت.</p><p>3. هذا الحدث هو حدث أسبوعي، حيث يتم إعادة تعيين القائمة وإعادة حسابها كل أسبوع.</p>",
        "last_week": "الأسبوع الماضي",
        "last_week_rank": "تفاصيل قائمة المتصدرين الأسبوع الماضي",
        "reward": "المكافآت",
        "rich_rank": "قائمة هدايا الغرفة",
        "rule": "القواعد",
        "rule_reward": "القواعد والمكافآت",
        "time_rank": "قائمة مدة الوقت",
        "title": "غرفة العائلة",
        "top1": "توب 1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "إطار الصورة 14 يومًا",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "دخولية 14 يوماً",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "إطار الصورة 14 يومًا",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "إطار الصورة 7 يومًا",
        "top2": "توب 2",
        "top3": "توب 3"
    },
    "TopUpRewards": "مكافآت الشحن",
    "treasure_chest": {
        "title": "تعليمات هدايا صندوق الكنز",
        "value1": "هناك ثلاثة أنواع من صناديق الكنز: خشبي، فضي، وذهبي.",
        "value2": "عندما تفتح صندوق الكنز، ستحصل على هدية عشوائية من الصندوق وتقوم بإرسالها.",
        "value3": "المرسل يكسب نقاط خبرة بناءً على الألماس المستهلك، بينما يتلقى المستلم عملات ونقاط جاذبية بناءً على قيمة الهدية من الصندوق.",
        "value4": "صندوق خشبي، بسعر 1500 ألماس، يحتوي على الهدايا التالية:",
        "value5": "صندوق فضي، بسعر 7500 ألماس، يحتوي على الهدايا التالية:",
        "value6": "صندوق ذهبي، بسعر 25000 ألماس، يحتوي على الهدايا التالية:",
        "value7": "هدايا صندوق الكنز هي فقط للترفيه والتفاعل الاجتماعي. أي إجراءات تؤثر على العدالة أو تستغل أخطاء المنتج سيتم حظرها. إذا تم اكتشاف ذلك، ستقوم المنصة بحظر الحساب وتحتفظ بالحق في اتخاذ الإجراءات القانونية."
    },
    "treasure_name": {
        "name1": "صندوق خشبي",
        "name2": "صندوق فضي",
        "name3": "صندوق ذهبي",
        "name4": "احتمالية"
    },
    "Value": "القيمة:",
    "Webname": {
        "addUid": "إضافة UID",
        "balance": "الرصيد:",
        "Confirm": "تأكيد",
        "err_uid": "UID غير صالح، يرجى إدخال مرة أخرى",
        "lang": "اختر اللغة",
        "Query": "بحث",
        "recharge": "مركز إعادة الشحن",
        "Recharge": "إعادة شحن",
        "self": "قناة",
        "uid": "تغيير UID",
        "uuserName": "لقب:",
        "Withdrawal": "سحب"
    },
    "Weekly_Cp": {
        "7days": "7 أيام",
        "back": "رد : .",
        "countdown": "العد التنازلي لهذا الأسبوع",
        "day": "أيام .",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>1.يتم حساب ترتيب على حسب مجموع هدايا النشاط التي المستخدم يمنحها الى حبيبتة (المضيفة) ، 1 ماسة =1 قيمة النشاط ، وسيحصل الثلاث الأوائل على مكافأة النشاط بعد انتهاء وقت الترتيب </p><p>2. هذا النشاط نشاط اسبوعي ؛ </p><p>3. سيتم توزيع مكافآت النشاط في غضون 3 أيام عمل بعد انتهاءالنشاط.</p>",
        "gift": "هدايا الحدث",
        "hour": "ساعة",
        "last_week": "الأسبوع الماضي",
        "last_week_rank": "قائمة الأسبوع الماضي",
        "minute": "دقيقة",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "المكافآت",
        "rule": "القواعد",
        "rule_reward": "القواعد والمكافآت",
        "seconds": "ثواني",
        "title": "توأم الروح",
        "top1": "الأول",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "إطار الصورة الرمزية لنجم الأسبوع",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "إطار الصورة الرمزية لأفضل دعم",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "زي نجم الأسبوع",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "الترتيب الثاني",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "الترتيب الثالث",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "أفضل ٤-٦",
        "top710": "أفضل ٧-١٠"
    },
    "Withdrawal": "تعليمات السحب",
    "withdrawalInstructions": {
        "text1": "ميزة السحب متاحة حاليًا في بلدان محددة فقط.",
        "text2": "قد يختلف وقت معالجة السحب حسب القناة المستخدمة.",
        "text3": "قد يكون المبلغ الفعلي المستلم أقل قليلاً من المبلغ المعروض بسبب تقلبات أسعار الصرف والرسوم.",
        "text4": "يمكنك السحب مرة واحدة فقط في اليوم.",
        "text5": "إذا واجهت أي مشاكل، يرجى الاتصال بنا."
    },
    "withdrawalLogin": {
        "accountId": "معرف حساب Pix",
        "accountIdTips": "",
        "accountIdtsa": "معرف حساب Pix لا يمكن أن يكون فارغًا",
        "accountType": "نوع حساب Pix",
        "code": "رمز التحقق:",
        "Confirm": "تأكيد",
        "documentId": "رقم الهوية الشخصية",
        "documentIdTips": "",
        "documentIdtsa": "نوع الهوية لا يمكن أن يكون فارغًا",
        "documentType": "نوع الهوية",
        "getAccount": "الحصول على الحساب",
        "getUserId": "يرجى إدخال معرف المستخدم",
        "incorrectAccount": "الحساب غير صحيح",
        "login": "تسجيل الدخول",
        "loginSuccessful": "تم تسجيل الدخول بنجاح",
        "name": "اسم مستخدم Pix",
        "nameTips": "",
        "nametsa": "يجب أن يتراوح الطول بين 5 و 100 حرفًا",
        "officialGroup": "إذا كان لديك أي أسئلة، يرجى الاتصال بالدعم الرسمي",
        "pocket": "رصيد Pocket Coin",
        "Pocket": "رصيد Pocket Coin غير كافٍ",
        "Send": "إرسال",
        "text": "سيتم إرسال رمز التحقق داخل التطبيق",
        "title": "سحب الأرباح",
        "title2": "تفاصيل السحب",
        "user_id": "معرف الحساب:",
        "Whatsapp": "حساب Whatsapp غير صحيح",
        "WhatsappTips": "",
        "applicationTime": "تاريخ الطلب",
        "amount": "مبلغ السحب",
        "success": "نجاح",
        "applicationSuccess": "تم تقديم الطلب"
    },
    "top1AnchorRewards": "مكافات المضيف توب ١",
    "top2_3AnchorRewards": "مكافآت توب ٢ و توب ٣ للمضيفين",
    "top4_10AnchorRewards": "مكافآت توب ٤ -توب ١٠  للمضيفين",
    "top1Icon7day": "إطار الصورة الرمزية لمدة سبعة أيام",
    "top1_2Icon7day": "تأثير الدخول لمدة سبعة أيام",
    "top3Icon7day": "إطار الصورة الرمزية لمدة سبعة أيام",
    "top1VIPRewards": "مكافآت توب ١ في الشحن",
    "top2_3VIPRewards": "مكافآت توب ٢ - توب ٣ في الشحن",
    "top4_10VIPRewards": "مكافآت توب ٤- توب ١٠ في الشحن",
    "relastionship": {
        "des": [
            "",
            "1. بعد تقديم هدية العلاقة، يمكن للطرف الآخر اختيار ما إذا كان يرغب في إقامة علاقة معك. لا يمكن أن توجد سوى علاقة واحدة بين شخصين.",
            "2. خلال 7 أيام تقويمية (UTC+3) بعد إنشاء العلاقة، لن تنخفض قيمة القرب. بعد فترة الحماية، إذا لم تزداد القرب بمقدار 50 درجة في يوم واحد، فسوف تنخفض بنسبة 10٪ في منتصف الليل في اليوم التالي (الحد الأدنى للانخفاض هو 1). عندما تصل القرب إلى 0، سيتم فك الارتباط في منتصف الليل في اليوم التالي. إذا لم تزد القرب بمقدار 50 درجة لمدة 10 أيام متتالية، فستنتهي العلاقة تلقائيًا عند منتصف الليل.",
            "3. يمكنك إنهاء العلاقة بعد 24 ساعة من إنشائها. بعد إنهائها، يمكنك إعادة إقامة العلاقة بعد 24 ساعة.",
            "4. لكل شخص 3 مواقع علاقة افتراضية. يمكنك إنفاق الماس لشراء المزيد، كل موقع يكلف 99,999 ماسة، ويمكنك شراء ما يصل إلى 10. يمكنك أيضًا زيادة المواقع برفع مستوى VIP الخاص بك.",
            "مستوى VIP",
            "إجمالي خانات العلاقات القابلة للتوسيع"
        ]
    },
    "gift_album_des1": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة ألبوم الأسبوع - \"جولة عالمية\" والحصول على مكافآت.",
    "gift_album_des2": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"محور الاهتمام\" والحصول على مكافآت.",
    "gift_album_des3": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"حماية SVIP\" والحصول على مكافآت.",
    "gift_album_des4": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"حفل زفاف الأحلام\" والحصول على مكافآت.",
    "gift_album_des5": "انتقل إلى [الملف الشخصي] - [حائط الهدايا] - [الألبوم] لعرض التفاصيل",
    "gift_album_des8": "إهداء الهدايا المذكورة أعلاه يمكن أن يساعده/ها في تفعيل مجموعة الدائم – 'حفلة عيد الميلاد' والحصول على المكافآت.",
    "gift_album_des7": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"نجم الغرفة\" والحصول على مكافآت.",
    "gift_harifata": "برج خليفة",
    "gift_sailing_hotel": "برج العرب",
    "gift_mosque": "المسجد الكبير",
    "gift_abatta": "برج اباتي",
    "gift_sphinx": "أبو الهول",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "نبض الحب",
    "gift_conf_lv2": "مغرم بالحب",
    "gift_conf_lv3": "حب للابد",
    "gift_conf_lv4": "لا احد سواك",
    "gift_habibi": "الاخوة",
    "gift_bestie": "الأخوات",
    "gift_couple": "CP",
    "gift_confidant": "رفيق",
    "weding_gift_kiss": "قبلة",
    "weding_gift_ring": "خاتم",
    "weding_gift_proposal": "طلب الزواج",
    "weding_gift_castle": "قلعة",
    "weding_gift_wedding_dress": "فستان زفاف",
    "weding_gift_wedding": "زفاف",
    "gift_album_des6": "القواعد",
    "guild_can_with": "متاح",
    "guild_with_ing": "قيد المعالجة",
    "guild_self_withdraw": "سحب ذاتي",
    "guild_transfer_to_leader": "تحويل إلى قائد الوكالة",
    "guild_salary_to_reseller": "تحويل إلى الموزّع",
    "guild_convert_to_diamond": "تحويل إلى ألماس",
    "guild_platform_settlement": "تسوية المنصة",
    "guild_withdrawal_records": "سجل السحب",
    "guild_current_withdrawable_pcoin": "الرصيد المتاح",
    "guild_transfer_pcoin_amount": "المبلغ للتحويل",
    "guild_all": "الكل",
    "guild_read_before_withdraw": "اقرأ قبل السحب:",
    "guild_withdraw_note_1": "إرسال",
    "guild_withdraw_note_2": "الرصيد غير كافٍ للسحب",
    "guild_min_withdraw_amount": "تأكيد الإرسال؟",
    "guild_withdraw_note_4": "إلغاء",
    "guild_appeal_to_platform": "تأكيد",
    "guild_submit_application": "طريقة السحب",
    "guild_withdraw_below_min": "سحب القائد",
    "guild_confirm_submit_application": "وقت الطلب",
    "guild_freeze_notice": "وقت المعالجة",
    "guild_communicate_with_leader": "سبب الرفض",
    "guild_cancel": "المبلغ المُسترد",
    "guild_confirm": "قيد الانتظار",
    "guild_withdrawal_method": "مكتمل",
    "guild_leader_withdraw": "مرفوض",
    "guild_status_timeout_rejected": "رُفض تلقائيًا (انتهاء المهلة)",
    "guild_status_unknown": "غير معروف",
    "guild_status_platform_review": "قيد مراجعة المنصة",
    "guild_status_guild_review": "قيد مراجعة الوكالة",
    "guild_status_timeout_rejected_2": "انتهت المهلة (مُرجع)",
    "guild_status_platform_rejected": "مرفوض من المنصة",
    "guild_status_guild_leader_approval": "يُحول للوكالة خلال <span>{n}</span> س",
    "guild_apply_time": "سجلات آخر 3 أشهر فقط",
    "guild_process_time": "أسئلة حول السحب؟",
    "guild_rejection_reason": "تواصل مع الدعم",
    "guild_amount_refunded": "موزّع موثّق",
    "guild_status_pending": "للموزّعين فقط",
    "guild_status_completed": "متاح",
    "guild_status_rejected": "مبلغ التحويل",
    "guild_show_last_3_months": "الوصول المتوقع",
    "guild_withdrawal_question": "تم بنجاح",
    "guild_contact_customer_service": "تحويل إلى ألماس",
    "guild_certified_reseller": "العملات المتاحة للتحويل",
    "guild_not_reseller_cannot_transfer": "تحويل",
    "guild_current_withdrawable": "تم التحويل",
    "guild_transfer_amount": "Coin مُسوّى",
    "guild_estimated_arrival": "تم إرسال الطلب",
    "guild_read_before_operation": "1. يُرجى تأكيد تفاصيل الدفع خارج الإنترنت مع الموزّع مسبقًا",
    "guild_transfer_note_1": "2. التحويلات متاحة للموزّع فقط",
    "guild_transfer_note_2": "تأكيد التحويل",
    "guild_confirm_transfer": "تأكيد الإرسال؟",
    "guild_confirm_submit_transfer": "سيتم خصم {n} عملة",
    "guild_deduct_pcoin_receive_diamond": "請 تنسيق تفاصيل الدفع مع الموزّع",
    "guild_communicate_with_reseller": "تمت العملية بنجاح",
    "guild_operation_success": "تحويل إلى ألماس",
    "guild_exchange_diamond": "العملات المتاحة للتحويل",
    "guild_current_exchangeable_pcoin": "تحويل",
    "guild_exchange": "تم التحويل بنجاح",
    "guild_exchange_success": "Coins قيد التسوية",
    "guild_settlement_pcoin_amount": "1. يُرجى تأكيد طريقة السحب مع فريق العمليات مسبقًا",
    "guild_settlement_note_1": "2. سيتم معالجة المدفوعات يوم الاثنين القادم",
    "guild_settlement_note_2": "3. الحد الأدنى للسحب: {n} Coin",
    "guild_settlement_min_amount": "تم إرسال الطلب",
    "guild_application_submitted": "سيتم خصم {n} Coin",
    "guild_deduct_pcoin": "يرجى تنسيق تفاصيل الدفع مع فريق العمليات",
    "guild_user_not": "المستخدم غير موجود",
    "guild_please_enter_amount": "أدخل المبلغ",
    "guild_insufficient_balance": "الرصيد غير كافٍ",
    "guild_please_enter_reseller_uid": "أدخل معرف RESELLER",
    "guild_please_search_reseller_first": "يرجى البحث عن RESELLER أولاً",
    "guild_select_hand": "اختر إجراءً",
    "guild_ci_hand": "1. سيؤدي هذا الإجراء إلى إرسال طلب إلى قائد النقابة،",
    "guild_offline_transfer_funds": "وسيتم الدفع لك يدويًا من قبل القائد",
    "guild_ci_hand_2": "2. يرجى تأكيد طريقة الدفع مع القائد مسبقًا (بطاقة بنكية / USDT، إلخ)",
    "guild_ci_hand_3": "3. الحد الأدنى للسحب هو {n} عملة",
    "guild_ci_hand_4": "4. إذا أكد القائد الدفع ولم تستلمه، يرجى الاحتفاظ بسجلات الدردشة و",
    "guild_ci_hand_5": "قدم شكوى إلى المنصة",
    "guild_ci_hand_6": "سيقوم النظام بتجميد {n} عملة حتى يعالجها القائد",
    "guild_ci_hand_7": "يرجى تأكيد قناة السحب مع القائد، والدفع يتم يدويًا",
    "guild_tips_1": "العملات القابلة للسحب أقل من الحد الأدنى",
    "guild_contact_service": "يرجى التواصل مع فريق التشغيل لترتيب الدفع",
    "guild_reseller_tips": "تم تحويل عملاتك إلى ألماس المستخدم الآخر. يُرجى التواصل معه بخصوص الدفع.",
    "gift_collection_detail_permanent_birthday": "حفلة ميلاد",
    "gift_collection_detail_permanent_roomstar": "نجم الغرفة",
    "gift_holy_sword": "السيف الطائر",
    "gift_volcano": "قوة البركان",
    "gift_emperor_come_world": "الملك",
    "gift_castle_of_love": "قلعة الحب",
    "gift_Immortal_god_war": "الخارق",
    "gift_king_of_gods": "ملك القوة",
    "birthday_gift_cybergift": "هدية سايبر",
    "birthday_gift_wish": "أمنية المصباح",
    "birthday_gift_cake": "كعكة ذهبية",
    "birthday_gift_lion": "مباركة الأسد",
    "birthday_gift_biggift": "هدية فاخرة",
    "guild_page_fee": "رسوم 2$ لكل عملية سحب",
    "guild_page_saudi": "السعودية",
    "guild_page_morocco": "المغرب",
    "guild_page_bank": "بنك",
    "guild_page_name": "الاسم (بالإنجليزية)",
    "guild_page_name_english": "يجب أن يكون الاسم بالإنجليزية",
    "guild_page_bank_number": "رقم الحساب البنكي",
    "guild_page_enter": "أدخل رقم حساب بنكي صحيح",
    "guild_page_address": "العنوان (بالإنجليزية)",
    "guild_page_address_english": "يجب أن يكون العنوان بالإنجليزية",
    "guild_page_country": "الدولة/المنطقة",
    "guild_page_holder_name": "اسم صاحب الحساب",
    "guild_page_sa": "مثال: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "الصيغة: العنوان، المنطقة، المدينة، الولاية، الدولة",
    "guild_page_minimum": "3. الحد الأدنى للسحب هو {n} عملة",
    "withdraw_input_amount": "أدخل المبلغ",
    "withdraw_submit": "سحب",
    "withdraw_quantity": "مبلغ السحب",
    "withdraw_actual_received": "المبلغ الفعلي المستلم",
    "common_confirm": "تأكيد",
    "common_cancel": "إلغاء",
    "withdraw_error_min_amount": "لم يتم الوصول للحد الأدنى للسحب",
    "withdraw_error_max_amount": "تجاوز الحد الأقصى للسحب",
    "withdraw_error_max_p_coin": "تجاوز العملات المتاحة للسحب",
    "guild_can_with_usd": "قابل للسحب (≈دولار امريكي {n})",
    "guild_pending_settlement": "في انتظار التسوية",
    "guild_funds_operation": "عملية الأموال",
    "guild_withdrawable_amount_title": "المبلغ القابل للسحب",
    "guild_withdrawable_amount_tip1": "1. لضمان أمان الأموال وتقليل المخاطر الأمنية، سيُجري النظام عمليات تدقيق لمراقبة المخاطر على كل معاملة دخل من العملات الذهبية. خلال فترة التدقيق، ستكون العملات الذهبية في حالة \"قيد التسوية\".",
    "guild_withdrawable_amount_tip2": "2. سيُستكمل التدقيق في غضون {s} ساعة كحد أقصى. بعد الموافقة على التدقيق، ستُحوّل العملات الذهبية من حالة \"قيد التسوية\" إلى حالة \"قابلة للسحب\". في حال فشل التدقيق، سيُعالج النظام المعاملة وفقًا للوائح.",
    "guild_withdrawable_amount_tip3": "3. في حالات استثنائية، مثل فشل السحب أو طلب استرداد المبلغ، يُمكن سحب العملات الذهبية فورًا.",
    "guild_got_it": "تم الفهم",
    "guild_pending_settlement_detail": "تفاصيل التسوية المعلقة",
    "guild_pending_settlement_tip": "سيتم تحويل أرباح العملات الذهبية إلى \"المبلغ القابل للسحب\" بعد الانتهاء من التسوية الآمنة، ومن المتوقع أن تدخل رصيدك القابل للسحب في غضون {s} ساعة كحد أقصى.",
    "guild_pending_settlement_amount": "مبلغ التسوية المعلق",
    "guild_pending_settlement_last_30_days": "يتم عرض سجلات الساعات الـ {n} الماضية فقط",
    "guild_pending_settlement_list_tips": "يتم عرض الأرباح المعلقة فقط خلال آخر {n} ساعة. إذا تم استخدام أو خصم المبالغ المعلقة، فلن تظهر هنا. يمكنك الذهاب إلى",
    "guild_pending_settlement_list_tips_btn": "صفحة سجل العملات",
    "guild_pending_settlement_list_tips_look": "عرض",
    "guild_pending_stamp_settled": "تم التسوية",
    "guild_pending_stamp_used": "تم الاستخدام",
    "guild_pending_stamp_deducted": "تم الخصم",
    "guild_record_guild_reward": "مكافآت الوكالة",
    "guild_record_gift": "استلام هدية",
    "guild_order_id": "معرّف الطلب",
    "guild_withdraw_record_total": "الإجمالي {s} معاملة",
    "guild_status_reseller_review": "قيد مراجعة reseller",
    "guild_status_security_review": "مراجعة أمان",
    "guild_select_withdraw_amount": "اختر مبلغ السحب",
    "guild_reference_fee": "رسوم الخدمة",
    "guild_change_channel": "تغيير",
    "guild_change_channel_title": "تغيير القناة",
    "guild_current_can_withdraw": "متاح للسحب حالياً",
    "guild_confirm_bind": "تأكيد الربط",
    "guild_bind_notice_title": "تنويه",
    "guild_bind_tip_1": "يجب أن يتطابق الاسم مع اسم الحساب الحقيقي.",
    "guild_bind_tip_2": "قد تؤدي معلومات الحساب غير الصحيحة إلى فشل السحب وعدم وصول الأموال. يرجى التأكد من صحة كل معلومة قبل الإرسال.",
    "guild_confirm_withdraw_info": "تأكيد معلومات السحب",
    "guild_withdraw_amount_label": "مبلغ السحب",
    "guild_estimated_arrival_time": "وقت الوصول المتوقع",
    "guild_confirm_info_tip": "يرجى التأكد بعناية من معلومات السحب، إذا كانت المعلومات غير صحيحة فلن يتم إيداع هذه الطلبية.",
    "guild_modify": "تعديل",
    "guild_confirm_submit": "تأكيد الإرسال",
    "guild_withdraw_success_tip": "من المتوقع وصول الأموال خلال {s} أيام عمل، يرجى الانتظار بصبر. يمكنك الذهاب إلى صفحة السحب - الزاوية اليمنى العليا [سجل السحب] لمتابعة التقدم.",
    "guild_name": "الاسم",
    "guild_bank_account": "حساب بنكي",
    "guild_please_enter": "يرجى الإدخال",
    "guild_withdraw_submit_success": "تم الإرسال بنجاح",
    "guild_withdraw_success_tip2": "من المتوقع وصول الأموال خلال {s} يوم عمل، يرجى الانتظار بصبر. يمكنك التحقق من حالة السحب عبر الذهاب إلى [صفحة السحب] - الزاوية العليا اليمنى [سجل السحب].",
    "guild_platform_settlement_success_tip": "سيتم معالجة الدفعات بشكل موحد يوم الاثنين المقبل. يرجى التحلي بالصبر. يمكنك متابعة التقدم من خلال الذهاب إلى [صفحة السحب] ثم النقر على [سجل السحب] في أعلى اليمين.",
    "guild_transfer_to_reseller": "تحويل إلى الموزع",
    "guild_transfer_to_reseller_label": "تحويل إلى الموزع",
    "guild_reseller_confirm_desc": "يرجى التأكد من أنك تواصلت مع الموزع بشأن ترتيبات الدفع. بعد النقر على \"تأكيد\"، سيتم خصم",
    "guild_reseller_confirm_tip_1": "1. يرجى التواصل مع الموزع مسبقًا بخصوص ترتيبات الدفع خارج التطبيق.",
    "guild_reseller_confirm_tip_2": "٢. إذا رفض الطرف الآخر، سيتم إعادة عملاتك تلقائيًا؛",
    "guild_reseller_confirm_tip_3": "3. الحد الأدنى للسحب هو {n} عملة.",
    "guild_leader_settle_subtitle": "سيقوم قائد الوكالة بتسوية الحساب معك خارج التطبيق",
    "guild_leader_confirm_desc": "يرجى التأكد من أنك قد ناقشت تفاصيل الدفع مع قائد الوكالة. عند النقر على \"تأكيد\"، سيتم خصم العملات.",
    "guild_leader_confirm_tip_1": "1. ستقدم هذه العملية طلبًا إلى قائد الوكالة، وسيقوم قائد الوكالة بتحويل الدفعة إليك خارج التطبيق؛",
    "guild_leader_confirm_tip_2": "2. يرجى تأكيد طريقة الدفع (بطاقة بنكية/USDT وغيرها) مع رئيس الوكالة مسبقًا؛ إذا رفض رئيس الوكالة، سيتم إعادة عملاتك تلقائيًا؛",
    "guild_leader_confirm_tip_3": "٣. الحد الأدنى للسحب هو {n} عملة؛",
    "guild_leader_confirm_tip_4": "4. إذا أكد قائد الوكالة أنه قد تم الدفع لكنك لم تستلم المال، يرجى الاحتفاظ بسجل الدردشة وتقديم شكوى إلى المنصة.",
    "guild_leader_confirm_tip_4_prefix": "5. إذا أكد قائد الوكالة أنه تم الدفع ولم تستلم المال، يرجى الاحتفاظ بسجل الدردشة وتقديم شكوى إلى المنصة.",
    "guild_leader_platform_appeal": "الاستئناف إلى المنصة",
    "pixNamePlaceholder": "أدخل اسم مستخدم pix",
    "pixIdType": "نوع الهوية",
    "transfer": {
        "bindSuccess": "تم الربط بنجاح",
        "error": "فشل العملية، يرجى المحاولة مرة أخرى لاحقًا."
    },
    "pixSelectIdTypePlaceholder": "اختر نوع الهوية",
    "pixIdPlaceholder": "أدخل {s} الخاص بك",
    "pixSelectAccountTypePlaceholder": "اختر نوع حساب pix",
    "pixAccountPlaceholder": "أدخل {s} الخاص بك",
    "whatsAppIdPlaceholder": "أدخل معرف الواتساب الخاص بك",
    "pixCpfLengthError": "يجب أن يتكون CPF من 11 رقمًا",
    "pixCnpjLengthError": "يجب أن يتكون CNPJ من 14 رقمًا",
    "pixCpfNotMatchError": "إدخالَي CPF غير متطابقين",
    "pixCnpjNotMatchError": "قيمتا CNPJ المدخلة غير متطابقتين",
    "pixFormatError": "خطأ في التنسيق",
    "notFilled": "لم يتم ملء {s}",
    "formatErrorCheck": "خطأ في التنسيق، يرجى التحقق.",
    "certi_tips": "تنبيه",
    "certi_tips1": "لحماية أمان الحساب وتقليل مخاطر الهجمات غير المشروعة، يجب إكمال التحقق قبل متابعة العملية. يرجى الذهاب إلى قسم \"خاصتي\" > \"مركز التحقق\" داخل التطبيق لإكمال التحقق قبل الاستمرار.",
    "certi_tips2": "اذهب للتحقق",
    "certi_tips3": "الإصدار الحالي قديم جدًا. يرجى التحديث والمحاولة مرة أخرى.",
    "certi_tips4": "لحماية أمان الحساب وتقليل مخاطر الهجمات غير القانونية، يجب إكمال التحقق لمتابعة الاستخدام.",
    "ff": "انطلاق الصاروخ! تحدَّ المضاعفات العالية!",
    "dd": "أقلع الآن",
    "guild_country": "الدولة/المنطقة",
    "guild_bank_name": "بنك",
    "guild_iban": "رقم الحساب البنكي الدولي (IBAN)",
    "guild_whatsapp": "واتساب",
    "guild_document_type": "نوع الهوية",
    "guild_document_id": "رقم الهوية",
    "guild_account_type": "نوع الحساب",
    "guild_address": "العنوان",
    "guild_settlement_weekly_process": "يتم التعامل بشكل موحد كل يوم إثنين",
    "withdrawal_channel": "قناة السحب",
    "guild_whatsapp_contact_tip": "يرجى ترك بيانات الاتصال الخاصة بك، وسنتواصل معك عبر واتساب",
    "guild_bind": "ربط",
    "guild_settlement_input_amount": "أدخل مبلغ السحب",
    "gift_sphinx6": "هرم",
    "gift_sphinx7": "برج موناس",
    "guild_no_more_data": "لا يوجد المزيد من المحتوى",
    "guild_bind_channel_toast": "يرجى ربط معلومات القناة أولاً"
}
